import { DropdownMenuItem } from "@certa/catalyst/components/Dropdown";
import { useIntl } from "react-intl";
import { Logout as LogoutIcon } from "@certa/icons/components/Logout";
import { WrapperWithIcon } from "../common";
import { useAuthActions } from "@certa/auth/authActions";

export const Logout = () => {
  const intl = useIntl();
  const authActions = useAuthActions();

  return (
    <DropdownMenuItem
      key="logout"
      value={intl.formatMessage({
        id: "loginPageInstances.logoutText"
      })}
      onSelect={authActions.userLogout}
      preventDropdownClose // on logout action hit, if it closes then it cause double redirection
    >
      <WrapperWithIcon icon={<LogoutIcon />}>
        {intl.formatMessage({
          id: "loginPageInstances.logoutText"
        })}
      </WrapperWithIcon>
    </DropdownMenuItem>
  );
};
